import { __extends } from "tslib";
import { Observable } from "../Misc/observable";
import { Gamepad } from "./gamepad";
/**
 * Defines supported buttons for DualShock compatible gamepads
 */
export var DualShockButton;
(function (DualShockButton) {
    /** Cross */
    DualShockButton[DualShockButton["Cross"] = 0] = "Cross";
    /** Circle */
    DualShockButton[DualShockButton["Circle"] = 1] = "Circle";
    /** Square */
    DualShockButton[DualShockButton["Square"] = 2] = "Square";
    /** Triangle */
    DualShockButton[DualShockButton["Triangle"] = 3] = "Triangle";
    /** L1 */
    DualShockButton[DualShockButton["L1"] = 4] = "L1";
    /** R1 */
    DualShockButton[DualShockButton["R1"] = 5] = "R1";
    /** Share */
    DualShockButton[DualShockButton["Share"] = 8] = "Share";
    /** Options */
    DualShockButton[DualShockButton["Options"] = 9] = "Options";
    /** Left stick */
    DualShockButton[DualShockButton["LeftStick"] = 10] = "LeftStick";
    /** Right stick */
    DualShockButton[DualShockButton["RightStick"] = 11] = "RightStick";
})(DualShockButton || (DualShockButton = {}));
/** Defines values for DualShock DPad  */
export var DualShockDpad;
(function (DualShockDpad) {
    /** Up */
    DualShockDpad[DualShockDpad["Up"] = 12] = "Up";
    /** Down */
    DualShockDpad[DualShockDpad["Down"] = 13] = "Down";
    /** Left */
    DualShockDpad[DualShockDpad["Left"] = 14] = "Left";
    /** Right */
    DualShockDpad[DualShockDpad["Right"] = 15] = "Right";
})(DualShockDpad || (DualShockDpad = {}));
/**
 * Defines a DualShock gamepad
 */
var DualShockPad = /** @class */ (function (_super) {
    __extends(DualShockPad, _super);
    /**
     * Creates a new DualShock gamepad object
     * @param id defines the id of this gamepad
     * @param index defines its index
     * @param gamepad defines the internal HTML gamepad object
     */
    function DualShockPad(id, index, gamepad) {
        var _this = _super.call(this, id.replace("STANDARD GAMEPAD", "SONY PLAYSTATION DUALSHOCK"), index, gamepad, 0, 1, 2, 3) || this;
        _this._leftTrigger = 0;
        _this._rightTrigger = 0;
        /** Observable raised when a button is pressed */
        _this.onButtonDownObservable = new Observable();
        /** Observable raised when a button is released */
        _this.onButtonUpObservable = new Observable();
        /** Observable raised when a pad is pressed */
        _this.onPadDownObservable = new Observable();
        /** Observable raised when a pad is released */
        _this.onPadUpObservable = new Observable();
        _this._buttonCross = 0;
        _this._buttonCircle = 0;
        _this._buttonSquare = 0;
        _this._buttonTriangle = 0;
        _this._buttonShare = 0;
        _this._buttonOptions = 0;
        _this._buttonL1 = 0;
        _this._buttonR1 = 0;
        _this._buttonLeftStick = 0;
        _this._buttonRightStick = 0;
        _this._dPadUp = 0;
        _this._dPadDown = 0;
        _this._dPadLeft = 0;
        _this._dPadRight = 0;
        _this.type = Gamepad.DUALSHOCK;
        return _this;
    }
    /**
     * Defines the callback to call when left trigger is pressed
     * @param callback defines the callback to use
     */
    DualShockPad.prototype.onlefttriggerchanged = function (callback) {
        this._onlefttriggerchanged = callback;
    };
    /**
     * Defines the callback to call when right trigger is pressed
     * @param callback defines the callback to use
     */
    DualShockPad.prototype.onrighttriggerchanged = function (callback) {
        this._onrighttriggerchanged = callback;
    };
    Object.defineProperty(DualShockPad.prototype, "leftTrigger", {
        /**
         * Gets the left trigger value
         */
        get: function () {
            return this._leftTrigger;
        },
        /**
         * Sets the left trigger value
         */
        set: function (newValue) {
            if (this._onlefttriggerchanged && this._leftTrigger !== newValue) {
                this._onlefttriggerchanged(newValue);
            }
            this._leftTrigger = newValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "rightTrigger", {
        /**
         * Gets the right trigger value
         */
        get: function () {
            return this._rightTrigger;
        },
        /**
         * Sets the right trigger value
         */
        set: function (newValue) {
            if (this._onrighttriggerchanged && this._rightTrigger !== newValue) {
                this._onrighttriggerchanged(newValue);
            }
            this._rightTrigger = newValue;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Defines the callback to call when a button is pressed
     * @param callback defines the callback to use
     */
    DualShockPad.prototype.onbuttondown = function (callback) {
        this._onbuttondown = callback;
    };
    /**
     * Defines the callback to call when a button is released
     * @param callback defines the callback to use
     */
    DualShockPad.prototype.onbuttonup = function (callback) {
        this._onbuttonup = callback;
    };
    /**
     * Defines the callback to call when a pad is pressed
     * @param callback defines the callback to use
     */
    DualShockPad.prototype.ondpaddown = function (callback) {
        this._ondpaddown = callback;
    };
    /**
     * Defines the callback to call when a pad is released
     * @param callback defines the callback to use
     */
    DualShockPad.prototype.ondpadup = function (callback) {
        this._ondpadup = callback;
    };
    DualShockPad.prototype._setButtonValue = function (newValue, currentValue, buttonType) {
        if (newValue !== currentValue) {
            if (newValue === 1) {
                if (this._onbuttondown) {
                    this._onbuttondown(buttonType);
                }
                this.onButtonDownObservable.notifyObservers(buttonType);
            }
            if (newValue === 0) {
                if (this._onbuttonup) {
                    this._onbuttonup(buttonType);
                }
                this.onButtonUpObservable.notifyObservers(buttonType);
            }
        }
        return newValue;
    };
    DualShockPad.prototype._setDPadValue = function (newValue, currentValue, buttonType) {
        if (newValue !== currentValue) {
            if (newValue === 1) {
                if (this._ondpaddown) {
                    this._ondpaddown(buttonType);
                }
                this.onPadDownObservable.notifyObservers(buttonType);
            }
            if (newValue === 0) {
                if (this._ondpadup) {
                    this._ondpadup(buttonType);
                }
                this.onPadUpObservable.notifyObservers(buttonType);
            }
        }
        return newValue;
    };
    Object.defineProperty(DualShockPad.prototype, "buttonCross", {
        /**
         * Gets the value of the `Cross` button
         */
        get: function () {
            return this._buttonCross;
        },
        /**
         * Sets the value of the `Cross` button
         */
        set: function (value) {
            this._buttonCross = this._setButtonValue(value, this._buttonCross, DualShockButton.Cross);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "buttonCircle", {
        /**
         * Gets the value of the `Circle` button
         */
        get: function () {
            return this._buttonCircle;
        },
        /**
         * Sets the value of the `Circle` button
         */
        set: function (value) {
            this._buttonCircle = this._setButtonValue(value, this._buttonCircle, DualShockButton.Circle);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "buttonSquare", {
        /**
         * Gets the value of the `Square` button
         */
        get: function () {
            return this._buttonSquare;
        },
        /**
         * Sets the value of the `Square` button
         */
        set: function (value) {
            this._buttonSquare = this._setButtonValue(value, this._buttonSquare, DualShockButton.Square);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "buttonTriangle", {
        /**
         * Gets the value of the `Triangle` button
         */
        get: function () {
            return this._buttonTriangle;
        },
        /**
         * Sets the value of the `Triangle` button
         */
        set: function (value) {
            this._buttonTriangle = this._setButtonValue(value, this._buttonTriangle, DualShockButton.Triangle);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "buttonOptions", {
        /**
         * Gets the value of the `Options` button
         */
        get: function () {
            return this._buttonOptions;
        },
        /**
         * Sets the value of the `Options` button
         */
        set: function (value) {
            this._buttonOptions = this._setButtonValue(value, this._buttonOptions, DualShockButton.Options);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "buttonShare", {
        /**
         * Gets the value of the `Share` button
         */
        get: function () {
            return this._buttonShare;
        },
        /**
         * Sets the value of the `Share` button
         */
        set: function (value) {
            this._buttonShare = this._setButtonValue(value, this._buttonShare, DualShockButton.Share);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "buttonL1", {
        /**
         * Gets the value of the `L1` button
         */
        get: function () {
            return this._buttonL1;
        },
        /**
         * Sets the value of the `L1` button
         */
        set: function (value) {
            this._buttonL1 = this._setButtonValue(value, this._buttonL1, DualShockButton.L1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "buttonR1", {
        /**
         * Gets the value of the `R1` button
         */
        get: function () {
            return this._buttonR1;
        },
        /**
         * Sets the value of the `R1` button
         */
        set: function (value) {
            this._buttonR1 = this._setButtonValue(value, this._buttonR1, DualShockButton.R1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "buttonLeftStick", {
        /**
         * Gets the value of the Left joystick
         */
        get: function () {
            return this._buttonLeftStick;
        },
        /**
         * Sets the value of the Left joystick
         */
        set: function (value) {
            this._buttonLeftStick = this._setButtonValue(value, this._buttonLeftStick, DualShockButton.LeftStick);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "buttonRightStick", {
        /**
         * Gets the value of the Right joystick
         */
        get: function () {
            return this._buttonRightStick;
        },
        /**
         * Sets the value of the Right joystick
         */
        set: function (value) {
            this._buttonRightStick = this._setButtonValue(value, this._buttonRightStick, DualShockButton.RightStick);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "dPadUp", {
        /**
         * Gets the value of D-pad up
         */
        get: function () {
            return this._dPadUp;
        },
        /**
         * Sets the value of D-pad up
         */
        set: function (value) {
            this._dPadUp = this._setDPadValue(value, this._dPadUp, DualShockDpad.Up);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "dPadDown", {
        /**
         * Gets the value of D-pad down
         */
        get: function () {
            return this._dPadDown;
        },
        /**
         * Sets the value of D-pad down
         */
        set: function (value) {
            this._dPadDown = this._setDPadValue(value, this._dPadDown, DualShockDpad.Down);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "dPadLeft", {
        /**
         * Gets the value of D-pad left
         */
        get: function () {
            return this._dPadLeft;
        },
        /**
         * Sets the value of D-pad left
         */
        set: function (value) {
            this._dPadLeft = this._setDPadValue(value, this._dPadLeft, DualShockDpad.Left);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DualShockPad.prototype, "dPadRight", {
        /**
         * Gets the value of D-pad right
         */
        get: function () {
            return this._dPadRight;
        },
        /**
         * Sets the value of D-pad right
         */
        set: function (value) {
            this._dPadRight = this._setDPadValue(value, this._dPadRight, DualShockDpad.Right);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Force the gamepad to synchronize with device values
     */
    DualShockPad.prototype.update = function () {
        _super.prototype.update.call(this);
        this.buttonCross = this.browserGamepad.buttons[0].value;
        this.buttonCircle = this.browserGamepad.buttons[1].value;
        this.buttonSquare = this.browserGamepad.buttons[2].value;
        this.buttonTriangle = this.browserGamepad.buttons[3].value;
        this.buttonL1 = this.browserGamepad.buttons[4].value;
        this.buttonR1 = this.browserGamepad.buttons[5].value;
        this.leftTrigger = this.browserGamepad.buttons[6].value;
        this.rightTrigger = this.browserGamepad.buttons[7].value;
        this.buttonShare = this.browserGamepad.buttons[8].value;
        this.buttonOptions = this.browserGamepad.buttons[9].value;
        this.buttonLeftStick = this.browserGamepad.buttons[10].value;
        this.buttonRightStick = this.browserGamepad.buttons[11].value;
        this.dPadUp = this.browserGamepad.buttons[12].value;
        this.dPadDown = this.browserGamepad.buttons[13].value;
        this.dPadLeft = this.browserGamepad.buttons[14].value;
        this.dPadRight = this.browserGamepad.buttons[15].value;
    };
    /**
     * Disposes the gamepad
     */
    DualShockPad.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.onButtonDownObservable.clear();
        this.onButtonUpObservable.clear();
        this.onPadDownObservable.clear();
        this.onPadUpObservable.clear();
    };
    return DualShockPad;
}(Gamepad));
export { DualShockPad };
//# sourceMappingURL=dualShockGamepad.js.map